// src/components/profile-input/formUtils.js
export const options = {
  // Gender options
  gender: ["Male", "Female"],

  // Status options
  status: ["Active", "Inactive", "On Hold", "Pending", "Completed"],

  // Profile creators
  profile_creators: ["Self", "Father", "Mother", "Brother", "Sister", "Uncle", "Aunt", "Guardian", "Admin User", "Other"],

  // Relations
  relations: ["Self", "Father", "Mother", "Brother", "Sister", "Uncle", "Aunt", "Guardian", "Other"],

  // Body Types
  body_types: ["Slim", "Average", "Athletic", "Heavy", "Muscular", "Petite", "Tall", "Stocky", "Lean", "Other"],

  // Complexions
  complexions: ["Very Fair", "Fair", "Wheatish", "Olive", "Brown", "Dark", "Tan", "Other"],

  // Religions
  religions: ["Islam", "Christianity", "Hinduism", "Sikhism", "Buddhism", "Judaism", "Other"],

  // Sect
  sects: {
    Islam: ["Sunni", "Shia", "Ahle Sunnat wal Jamaat Hanafi Barelvi", "Other"],
    Christianity: ["Catholic", "Protestant", "Orthodox", "Other"],
    Hinduism: ["Vaishnavism", "Shaivism", "Shaktism", "Smartism", "Other"],
    Sikhism: ["Amritdhari", "Sahajdhari", "Keshdhari", "Other"],
    Other: ["Other"]
  },

  // Caste
  castes: {
    Islam: ["Syed", "Arain", "Sheikh", "Mughal", "Pathan", "Rajput", "Qasrani", "Other"],
    Hinduism: ["Brahmin", "Kshatriya", "Vaishya", "Shudra", "Other"],
    Christianity: ["Latin Catholic", "Syrian Christian", "Other"],
    Sikhism: ["Jat", "Khatri", "Arora", "Other"],
    Other: ["Other"]
  },

  // Practice Levels
  practice_levels: ["Strict", "Moderate", "Liberal", "Non-practicing", "Other"],

  // Marital Statuses
  marital_statuses: ["Never Married", "Divorced", "Widowed", "Separated", "Other"],

  // Employment Types
  employment_types: ["Full-time", "Part-time", "Self-employed", "Unemployed", "Student", "Retired", "Homemaker", "Other"],

  // Countries
  countries: [
    "Pakistan", "India", "Bangladesh", "United States", "United Kingdom", "Canada", "Australia",
    "United Arab Emirates", "Saudi Arabia", "Oman", "Qatar", "Kuwait", "Bahrain", "Malaysia",
    "Singapore", "Other"
  ],

  // Major Cities
  major_cities: {
    Pakistan: ["Lahore", "Karachi", "Islamabad", "Rawalpindi", "Faisalabad", "Multan", "Hyderabad", "Peshawar", "Quetta", "Gujranwala", "Other"],
    India: ["Mumbai", "Delhi", "Bangalore", "Hyderabad", "Chennai", "Kolkata", "Pune", "Ahmedabad", "Other"],
    "United States": ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix", "Philadelphia", "Other"],
    "United Kingdom": ["London", "Birmingham", "Manchester", "Leeds", "Glasgow", "Liverpool", "Other"],
    "United Arab Emirates": ["Dubai", "Abu Dhabi", "Sharjah", "Al Ain", "Ajman", "Other"],
    "Saudi Arabia": ["Riyadh", "Jeddah", "Mecca", "Medina", "Dammam", "Other"],
    Other: ["Other"]
  },

  // Languages
  languages: [
    "Urdu", "English", "Hindi", "Punjabi", "Sindhi", "Pashto", "Balochi", "Saraiki", "Arabic", "Bengali",
    "Tamil", "Telugu", "Marathi", "Gujarati", "Malayalam", "Kannada", "French", "Spanish", "Other"
  ],

  // Education Levels (simplified)
  education_levels: [
    "Matric", "Intermediate", "Diploma", "Bachelor's Degree", "Master's Degree", "PhD", "Other"
  ],

  // Family Types
  family_types: ["Nuclear", "Joint", "Extended", "Separate", "Other"],

  // Family Statuses
  family_statuses: ["Upper-class", "Upper-middle-class", "Middle-class", "Lower-middle-class", "Affluent", "Moderate", "Other"],

  // Blood Groups
  blood_groups: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-", "Other", "Unknown"],

  // Disabilities
  disabilities: ["None", "Physical", "Visual", "Hearing", "Speech", "Learning", "Other"],

  // Dietary Preferences
  dietary_preferences: ["Halal", "Vegetarian", "Non-Vegetarian", "Eggetarian", "Vegan", "Flexitarian", "Other"],

  // Yes/No options
  yes_no: ["Yes", "No"],

  // Smoking Habits
  smoking_habits: ["No", "Yes", "Occasionally", "Regular", "Social Smoker", "Ex-Smoker", "Other"],

  // Drinking Habits
  drinking_habits: ["No", "Yes", "Occasionally", "Regular", "Social Drinker", "Ex-Drinker", "Other"],

  // Residential Statuses
  residential_statuses: ["Own House", "Rented", "Family House", "Mortgage", "Other"]
};

export const steps = [
  "Basic Info",
  "Personal Details",
  "Education & Profession",
  "Family & Health",
  "Preferences"
];

// WhatsApp number constant
export const WHATSAPP_NUMBER = "+923425262121";

// Helper function to generate unique profile ID
export const generateProfileId = (gender = "Female", counter = null) => {
  const normalizedGender = gender === "Male" ? "Male" : "Female";
  const genderPrefix = normalizedGender === "Male" ? "M" : "F";
  const currentDate = new Date();
  const year = currentDate.getFullYear().toString().slice(-2);
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const datePart = `${year}${month}${day}`;

  // Use provided counter or generate random
  let uniquePart;
  if (counter !== null) {
    uniquePart = String(counter).padStart(3, "0");
  } else {
    // Generate from timestamp (last 3 digits)
    const timestamp = Date.now().toString();
    uniquePart = timestamp.slice(-3);
  }

  return `${genderPrefix}${datePart}${uniquePart}`;
};

export const getDefaultFormData = () => {
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, "0");
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const year = currentDate.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;
  const initialProfileId = generateProfileId("Female");

  return {
    // Basic Information
    profile_id: initialProfileId,
    status: "Active",
    profile_created_date: formattedDate,
    profile_created_by: "",
    profile_created_by_other: "",

    // Guardian Details
    guardian_details: {
      guardian_name: "",
      relation: "Father",
      relation_other: "",
      contact_number: "",
      country_code: "",
      whatsapp_number: "",
      whatsapp_country_code: ""
    },

    // Personal Details
    personal_details: {
      gender: "Female",
      full_name: "",
      date_of_birth: "",
      place_of_birth: "",
      nationality: "Pakistani",
      mother_tongue: "",
      mother_tongue_other: "",
      languages_known: [],
      mobile_number: "",
      occupation: "",
      permanent_address: ""
    },

    // Physical Details
    physical_details: {
      height: {
        value: "",
        unit: "feet"
      },
      weight_kg: "",
      body_type: "",
      body_type_other: "",
      complexion: "",
      complexion_other: ""
    },

    // Religious Details
    religious_details: {
      religion: "Islam",
      religion_other: "",
      sect: "",
      sect_other: "",
      caste: "",
      caste_other: "",
      religious_practice_level: "Liberal",
      practice_level_other: ""
    },

    // Marital Details
    marital_details: {
      marital_status: "Never Married",
      marital_status_other: "",
      children: 0
    },

    // Education
    education: {
      highest_degree: "",
      highest_degree_other: "",
      degree: "",
      institution: "",
      other_qualifications: []
    },

    // Profession
    profession: {
      job_title: "",
      organization: "",
      employment_type: "Full-time",
      employment_type_other: "",
      monthly_income: "",
      work_location: ""
    },

    // Residence
    residence: {
      residential_status: "Own House",
      residential_status_other: "",
      city: "",
      city_other: "",
      state: "",
      country: "Pakistan",
      country_other: ""
    },

    // Family
    family: {
      family_type: "Nuclear",
      family_type_other: "",
      father_profession: "",
      mother_profession: "",
      family_status: "Middle-class",
      family_status_other: "",
      siblings: {
        total: 0,
        brothers: {
          total: 0,
          married: 0
        },
        sisters: {
          total: 0,
          married: 0
        }
      }
    },

    // Health
    health: {
      blood_group: "",
      blood_group_other: "",
      disability: "None",
      disability_other: "",
      medical_conditions: "",
      smoking: "No",
      smoking_other: "",
      drinking: "No",
      drinking_other: ""
    },

    // Habits and Lifestyle
    habits_and_lifestyle: {
      diet: "Halal",
      diet_other: "",
      hobbies: [],
      sports_interest: [],
      description: ""
    },

    // Documents Verification
    documents_verification: {
      cnic_verified: false,
      education_verified: false,
      employment_verified: false
    },

    // Preferences
    preferences: {
      min_age: "",
      max_age: "",
      min_height: {
        value: "",
        unit: "feet"
      },
      education: "",
      education_other: "",
      profession: "Any",
      profession_other: "",
      religion: "Islam",
      religion_other: "",
      sect: "",
      sect_other: "",
      caste: "Any",
      caste_other: "",
      city: "Any",
      city_other: "",
      country: "",
      marital_status: "Any",
      marital_status_other: "",
      profession_preference: [],
      location_preference: [],
      preferred_languages: [],
      smoking_preference: "Non-smoker",
      smoking_preference_other: "",
      drinking_preference: "Non-drinker",
      drinking_preference_other: ""
    }
  };
};

// Helper function to check if a field has "Other" option
export const hasOtherOption = (fieldName) => {
  const otherFields = [
    'profile_created_by',
    'relation',
    'body_type',
    'complexion',
    'religion',
    'sect',
    'caste',
    'practice_level',
    'marital_status',
    'employment_type',
    'country',
    'city',
    'education',
    'family_type',
    'family_status',
    'blood_group',
    'disability',
    'diet',
    'smoking',
    'drinking',
    'mother_tongue',
    'smoking_preference',
    'drinking_preference'
  ];
  return otherFields.includes(fieldName);
};

// Helper function to get the actual value considering "Other" option
export const getActualValue = (selectedValue, otherValue) => {
  return selectedValue === "Other" && otherValue ? otherValue : selectedValue;
};

// Helper function to get display value considering "Other" option
export const getDisplayValue = (selectedValue, otherValue) => {
  if (selectedValue === "Other" && otherValue) {
    return `Other: ${otherValue}`;
  }
  return selectedValue;
};

// Phone number validation - accept any non-empty format
export const validatePhoneNumber = (phoneNumber, country = "Pakistan") => {
  if (!phoneNumber) return false;
  return phoneNumber.trim().length > 0;
};

// Parse phone number - store exactly as entered
export const parsePhoneNumber = (input) => {
  if (!input) return { countryCode: "", phoneNumber: "" };

  const trimmed = input.trim();

  // If it starts with +, extract country code
  if (trimmed.startsWith('+')) {
    const match = trimmed.match(/^\+(\d{1,3})/);
    if (match) {
      return {
        countryCode: `+${match[1]}`,
        phoneNumber: trimmed.substring(match[0].length)
      };
    }
  }

  // If it starts with 00, extract country code
  if (trimmed.startsWith('00')) {
    const match = trimmed.match(/^00(\d{1,3})/);
    if (match) {
      return {
        countryCode: `+${match[1]}`,
        phoneNumber: trimmed.substring(match[0].length)
      };
    }
  }

  // For any other format, store the entire number as phoneNumber
  return {
    countryCode: "",
    phoneNumber: trimmed // Store exactly as entered
  };
};

// Format phone number for display
export const formatPhoneNumber = (countryCode, phoneNumber) => {
  if (!phoneNumber) return "";

  const cleaned = phoneNumber.replace(/\D/g, '');

  if (countryCode) {
    if (countryCode === "+92") {
      if (cleaned.length === 10) {
        return `${countryCode} ${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
      }
    }
    return `${countryCode}${cleaned}`;
  }

  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  return cleaned;
};

// Format phone number from form data
export const formatPhoneFromFormData = (guardianDetails, type = 'contact') => {
  if (type === 'contact') {
    return formatPhoneNumber(
      guardianDetails.country_code || "",
      guardianDetails.contact_number || ""
    );
  } else {
    return formatPhoneNumber(
      guardianDetails.whatsapp_country_code || "",
      guardianDetails.whatsapp_number || ""
    );
  }
};

// Validation functions
export const validateStep = (step, formData) => {
  const errors = {};

  switch (step) {
    case 0: // Basic Info
      if (!formData.profile_created_by) {
        errors.profile_created_by = "Profile creator is required";
      } else if (formData.profile_created_by === "Other" && !formData.profile_created_by_other) {
        errors.profile_created_by_other = "Please specify profile creator";
      }

      if (!formData.guardian_details.guardian_name) {
        errors.guardian_name = "Guardian name is required";
      }

      const contactNumber = formData.guardian_details.contact_number;
      if (!contactNumber) {
        errors.guardian_contact = "Guardian contact number is required";
      } else if (contactNumber.trim() === "") {
        errors.guardian_contact = "Guardian contact number is required";
      }

      return { isValid: Object.keys(errors).length === 0, errors };

    case 1: // Personal Details
      if (!formData.personal_details.full_name) {
        errors.full_name = "Full name is required";
      }

      if (!formData.personal_details.date_of_birth) {
        errors.date_of_birth = "Date of birth is required";
      } else {
        const age = calculateAge(formData.personal_details.date_of_birth);
        if (age < 18) {
          errors.date_of_birth = "Must be at least 18 years old";
        } else if (age > 100) {
          errors.date_of_birth = "Please enter a valid date of birth";
        }
      }

      const mobileNumber = formData.personal_details.mobile_number;
      if (!mobileNumber) {
        errors.mobile_number = "Mobile number is required";
      } else if (mobileNumber.trim() === "") {
        errors.mobile_number = "Mobile number is required";
      }

      if (!formData.physical_details.height.value) {
        errors.height = "Height is required";
      }

      if (!formData.residence.country) {
        errors.country = "Country is required";
      }

      if (!formData.residence.city) {
        errors.city = "City is required";
      }

      return { isValid: Object.keys(errors).length === 0, errors };

    case 2: // Education & Profession
      if (!formData.education.highest_degree) {
        errors.highest_degree = "Highest degree is required";
      } else if (formData.education.highest_degree === "Other" && !formData.education.highest_degree_other) {
        errors.highest_degree_other = "Please specify highest degree";
      }

      if (!formData.profession.job_title) {
        errors.job_title = "Job title is required";
      }

      if (!formData.religious_details.caste) {
        errors.caste = "Caste is required";
      } else if (formData.religious_details.caste === "Other" && !formData.religious_details.caste_other) {
        errors.caste_other = "Please specify caste";
      }

      if (!formData.marital_details.marital_status) {
        errors.marital_status = "Marital status is required";
      } else if (formData.marital_details.marital_status === "Other" && !formData.marital_details.marital_status_other) {
        errors.marital_status_other = "Please specify marital status";
      }

      const monthlyIncome = formData.profession.monthly_income;
      if (monthlyIncome && typeof monthlyIncome === 'string') {
        if (monthlyIncome.trim() === "") {
          errors.monthly_income = "Monthly income is required";
        }
      }

      return { isValid: Object.keys(errors).length === 0, errors };

    case 3: // Family & Health
      if (!formData.health.smoking) {
        errors.smoking = "Smoking habit is required";
      } else if (formData.health.smoking === "Other" && !formData.health.smoking_other) {
        errors.smoking_other = "Please specify smoking habit";
      }

      if (!formData.health.drinking) {
        errors.drinking = "Drinking habit is required";
      } else if (formData.health.drinking === "Other" && !formData.health.drinking_other) {
        errors.drinking_other = "Please specify drinking habit";
      }

      if (!formData.habits_and_lifestyle.diet) {
        errors.diet = "Dietary preference is required";
      } else if (formData.habits_and_lifestyle.diet === "Other" && !formData.habits_and_lifestyle.diet_other) {
        errors.diet_other = "Please specify dietary preference";
      }

      return { isValid: Object.keys(errors).length === 0, errors };

    case 4: // Preferences
      const minAge = parseInt(formData.preferences.min_age) || 0;
      const maxAge = parseInt(formData.preferences.max_age) || 0;

      if (!formData.preferences.min_age) {
        errors.min_age = "Minimum age is required";
      } else if (minAge < 18) {
        errors.min_age = "Minimum age must be at least 18";
      }

      if (!formData.preferences.max_age) {
        errors.max_age = "Maximum age is required";
      } else if (maxAge && minAge) {
        if (maxAge < minAge) {
          errors.max_age = "Maximum age must be greater than minimum age";
        }
      }

      if (!formData.preferences.religion) {
        errors.religion_preference = "Religion preference is required";
      } else if (formData.preferences.religion === "Other" && !formData.preferences.religion_other) {
        errors.religion_preference_other = "Please specify religion preference";
      }

      if (!formData.preferences.smoking_preference) {
        errors.smoking_preference = "Smoking preference is required";
      } else if (formData.preferences.smoking_preference === "Other" && !formData.preferences.smoking_preference_other) {
        errors.smoking_preference_other = "Please specify smoking preference";
      }

      if (!formData.preferences.drinking_preference) {
        errors.drinking_preference = "Drinking preference is required";
      } else if (formData.preferences.drinking_preference === "Other" && !formData.preferences.drinking_preference_other) {
        errors.drinking_preference_other = "Please specify drinking preference";
      }

      return { isValid: Object.keys(errors).length === 0, errors };

    default:
      return { isValid: true, errors: {} };
  }
};

// Calculate age from date of birth (DD-MM-YYYY)
export const calculateAge = (dob) => {
  if (!dob) return 0;

  try {
    // Parse DD-MM-YYYY format
    const [day, month, year] = dob.split('-').map(Number);
    const birthDate = new Date(year, month - 1, day);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  } catch (error) {
    return 0;
  }
};

// Convert height between cm and feet
export const convertHeight = {
  cmToFeet: (cm) => {
    if (!cm) return { feet: 0, inches: 0 };
    const totalInches = cm / 2.54;
    const feet = Math.floor(totalInches / 12);
    const inches = Math.round(totalInches % 12);
    return { feet, inches };
  },

  feetToCm: (feet, inches) => {
    if (!feet && !inches) return 0;
    const totalInches = (parseInt(feet) || 0) * 12 + (parseInt(inches) || 0);
    return Math.round(totalInches * 2.54);
  },

  parseHeightString: (heightString) => {
    if (!heightString) return { value: "", unit: "feet" };

    if (heightString.includes("'")) {
      const parts = heightString.split("'");
      const feet = parts[0];
      const inches = parts[1] ? parts[1].replace('"', '') : "0";
      return { value: `${feet}'${inches}"`, unit: "feet" };
    } else if (heightString.includes("cm")) {
      const cm = heightString.replace("cm", "").trim();
      return { value: cm, unit: "cm" };
    }

    return { value: heightString, unit: "feet" };
  }
};

// Validate date (DD-MM-YYYY)
export const isValidDate = (dateString) => {
  if (!dateString) return false;

  const regex = /^\d{2}-\d{2}-\d{4}$/;
  if (!regex.test(dateString)) return false;

  const [day, month, year] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);

  return (
    date.getDate() === day &&
    date.getMonth() === month - 1 &&
    date.getFullYear() === year
  );
};

// Get filtered options based on dependencies
export const getFilteredOptions = (key, dependencies = {}) => {
  switch (key) {
    case "sect":
      return options.sects[dependencies.religion] || options.sects.Other;
    case "caste":
      return options.castes[dependencies.religion] || options.castes.Other;
    case "city":
      return options.major_cities[dependencies.country] || options.major_cities.Other;
    default:
      return options[key] || [];
  }
};

// Calculate BMI
export const calculateBMI = (weightKg, heightCm) => {
  if (!weightKg || !heightCm) return null;
  const heightM = heightCm / 100;
  return (weightKg / (heightM * heightM)).toFixed(1);
};

// Get BMI category
export const getBMICategory = (bmi) => {
  if (!bmi) return "";
  if (bmi < 18.5) return "Underweight";
  if (bmi < 25) return "Normal";
  if (bmi < 30) return "Overweight";
  return "Obese";
};

// Helper to combine main and other fields
export const combineField = (mainValue, otherValue) => {
  if (!mainValue || mainValue === '') return '';
  if (mainValue === 'Other' && otherValue && otherValue !== '') {
    return otherValue;
  }
  return mainValue;
};

// Country code mapping based on options.countries
const getCountryCodeMap = () => {
  const map = {};
  // This mapping should be maintained based on standard country codes
  // You can expand this list as needed
  const countryCodes = {
    'Pakistan': '92',
    'India': '91',
    'Bangladesh': '880',
    'United States': '1',
    'United Kingdom': '44',
    'Canada': '1',
    'Australia': '61',
    'United Arab Emirates': '971',
    'Saudi Arabia': '966',
    'Oman': '968',
    'Qatar': '974',
    'Kuwait': '965',
    'Bahrain': '973',
    'Malaysia': '60',
    'Singapore': '65'
  };
  
  options.countries.forEach(country => {
    if (country !== 'Other' && countryCodes[country]) {
      map[country] = countryCodes[country];
    }
  });
  
  return map;
};

// Create a cleaned profile object with combined fields
export const createCleanedProfile = (formData) => {
  if (!formData) return null;

  const countryCodeMap = getCountryCodeMap();

  // Helper function to format phone numbers with country code
  const formatPhoneNumber = (phoneNumber, countryCode = '') => {
    if (!phoneNumber || phoneNumber === '') return '';
    
    // If already has +, return as is (already has country code)
    if (phoneNumber.startsWith('+')) {
      return phoneNumber;
    }
    
    // Clean the phone number (remove spaces, dashes, etc.)
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    
    // Priority 1: Use explicitly provided country code from form data
    if (countryCode && countryCode !== '') {
      // Ensure country code has + prefix
      const formattedCountryCode = countryCode.startsWith('+') ? countryCode : `+${countryCode}`;
      // Remove leading zero if present (common in local formats)
      const numberWithoutLeadingZero = cleanedNumber.startsWith('0') ? cleanedNumber.substring(1) : cleanedNumber;
      return `${formattedCountryCode}${numberWithoutLeadingZero}`;
    }
    
    // Priority 2: Try to get country code from residence country
    const residenceCountry = formData.residence?.country || '';
    if (residenceCountry && residenceCountry !== 'Other' && countryCodeMap[residenceCountry]) {
      const numberWithoutLeadingZero = cleanedNumber.startsWith('0') ? cleanedNumber.substring(1) : cleanedNumber;
      return `+${countryCodeMap[residenceCountry]}${numberWithoutLeadingZero}`;
    }
    
    // Priority 3: Try to get country code from nationality
    const nationality = formData.personal_details?.nationality || '';
    if (nationality && nationality !== 'Other' && countryCodeMap[nationality]) {
      const numberWithoutLeadingZero = cleanedNumber.startsWith('0') ? cleanedNumber.substring(1) : cleanedNumber;
      return `+${countryCodeMap[nationality]}${numberWithoutLeadingZero}`;
    }
    
    // Priority 4: Try to determine from work location
    const workLocation = formData.profession?.work_location || '';
    if (workLocation && workLocation !== 'Other' && countryCodeMap[workLocation]) {
      const numberWithoutLeadingZero = cleanedNumber.startsWith('0') ? cleanedNumber.substring(1) : cleanedNumber;
      return `+${countryCodeMap[workLocation]}${numberWithoutLeadingZero}`;
    }
    
    // If we still don't have a country code, return the original number
    // This should not happen in production as all numbers should have country codes
    console.warn('Could not determine country code for number:', phoneNumber);
    return phoneNumber;
  };

  return {
    profile_id: formData.profile_id,
    status: formData.status || 'Active',
    profile_created_date: formData.profile_created_date,
    profile_created_by: formData.profile_created_by === "Other" && formData.profile_created_by_other 
      ? formData.profile_created_by_other 
      : formData.profile_created_by,

    guardian_details: {
      guardian_name: formData.guardian_details?.guardian_name || '',
      relation: formData.guardian_details?.relation === "Other" && formData.guardian_details?.relation_other 
        ? formData.guardian_details.relation_other 
        : formData.guardian_details?.relation || '',
      contact_number: formatPhoneNumber(
        formData.guardian_details?.contact_number,
        formData.guardian_details?.country_code
      ),
      whatsapp_number: formatPhoneNumber(
        formData.guardian_details?.whatsapp_number,
        formData.guardian_details?.whatsapp_country_code
      )
    },

    personal_details: {
      full_name: formData.personal_details?.full_name || '',
      gender: formData.personal_details?.gender || '',
      date_of_birth: formData.personal_details?.date_of_birth || '',
      place_of_birth: formData.personal_details?.place_of_birth || '',
      nationality: formData.personal_details?.nationality || '',
      mother_tongue: formData.personal_details?.mother_tongue === "Other" && formData.personal_details?.mother_tongue_other 
        ? formData.personal_details.mother_tongue_other 
        : formData.personal_details?.mother_tongue || '',
      languages_known: formData.personal_details?.languages_known || [],
      mobile_number: formatPhoneNumber(
        formData.personal_details?.mobile_number,
        formData.guardian_details?.country_code
      ),
      occupation: formData.personal_details?.occupation || '',
      permanent_address: formData.personal_details?.permanent_address || ''
    },

    physical_details: {
      height: {
        value: formData.physical_details?.height?.value || '',
        unit: formData.physical_details?.height?.unit || 'feet'
      },
      weight_kg: formData.physical_details?.weight_kg || '',
      body_type: formData.physical_details?.body_type === "Other" && formData.physical_details?.body_type_other 
        ? formData.physical_details.body_type_other 
        : formData.physical_details?.body_type || '',
      complexion: formData.physical_details?.complexion === "Other" && formData.physical_details?.complexion_other 
        ? formData.physical_details.complexion_other 
        : formData.physical_details?.complexion || ''
    },

    religious_details: {
      religion: formData.religious_details?.religion === "Other" && formData.religious_details?.religion_other 
        ? formData.religious_details.religion_other 
        : formData.religious_details?.religion || '',
      sect: formData.religious_details?.sect === "Other" && formData.religious_details?.sect_other 
        ? formData.religious_details.sect_other 
        : formData.religious_details?.sect || '',
      caste: formData.religious_details?.caste === "Other" && formData.religious_details?.caste_other 
        ? formData.religious_details.caste_other 
        : formData.religious_details?.caste || '',
      religious_practice_level: formData.religious_details?.religious_practice_level === "Other" && formData.religious_details?.practice_level_other 
        ? formData.religious_details.practice_level_other 
        : formData.religious_details?.religious_practice_level || ''
    },

    marital_details: {
      marital_status: formData.marital_details?.marital_status === "Other" && formData.marital_details?.marital_status_other 
        ? formData.marital_details.marital_status_other 
        : formData.marital_details?.marital_status || '',
      children: formData.marital_details?.children !== undefined ? formData.marital_details.children : 0
    },

    education: {
      highest_degree: formData.education?.highest_degree === "Other" && formData.education?.highest_degree_other 
        ? formData.education.highest_degree_other 
        : formData.education?.highest_degree || '',
      degree: formData.education?.degree || '',
      institution: formData.education?.institution || '',
      other_qualifications: formData.education?.other_qualifications || []
    },

    profession: {
      job_title: formData.profession?.job_title || '',
      organization: formData.profession?.organization || '',
      employment_type: formData.profession?.employment_type === "Other" && formData.profession?.employment_type_other 
        ? formData.profession.employment_type_other 
        : formData.profession?.employment_type || '',
      monthly_income: formData.profession?.monthly_income || '',
      work_location: formData.profession?.work_location || ''
    },

    residence: {
      residential_status: formData.residence?.residential_status === "Other" && formData.residence?.residential_status_other 
        ? formData.residence.residential_status_other 
        : formData.residence?.residential_status || '',
      city: formData.residence?.city === "Other" && formData.residence?.city_other 
        ? formData.residence.city_other 
        : formData.residence?.city || '',
      state: formData.residence?.state || '',
      country: formData.residence?.country === "Other" && formData.residence?.country_other 
        ? formData.residence.country_other 
        : formData.residence?.country || ''
    },

    family: {
      family_type: formData.family?.family_type === "Other" && formData.family?.family_type_other 
        ? formData.family.family_type_other 
        : formData.family?.family_type || '',
      father_profession: formData.family?.father_profession || '',
      mother_profession: formData.family?.mother_profession || '',
      family_status: formData.family?.family_status === "Other" && formData.family?.family_status_other 
        ? formData.family.family_status_other 
        : formData.family?.family_status || '',
      siblings: {
        brothers: {
          total: formData.family?.siblings?.brothers?.total || 0,
          married: formData.family?.siblings?.brothers?.married || 0
        },
        sisters: {
          total: formData.family?.siblings?.sisters?.total || 0,
          married: formData.family?.siblings?.sisters?.married || 0
        }
      }
    },

    health: {
      blood_group: formData.health?.blood_group === "Other" && formData.health?.blood_group_other 
        ? formData.health.blood_group_other 
        : formData.health?.blood_group || '',
      disability: formData.health?.disability === "Other" && formData.health?.disability_other 
        ? formData.health.disability_other 
        : formData.health?.disability || '',
      medical_conditions: formData.health?.medical_conditions || '',
      smoking: formData.health?.smoking === "Other" && formData.health?.smoking_other 
        ? formData.health.smoking_other 
        : formData.health?.smoking || '',
      drinking: formData.health?.drinking === "Other" && formData.health?.drinking_other 
        ? formData.health.drinking_other 
        : formData.health?.drinking || ''
    },

    habits_and_lifestyle: {
      diet: formData.habits_and_lifestyle?.diet === "Other" && formData.habits_and_lifestyle?.diet_other 
        ? formData.habits_and_lifestyle.diet_other 
        : formData.habits_and_lifestyle?.diet || '',
      hobbies: formData.habits_and_lifestyle?.hobbies || [],
      sports_interest: formData.habits_and_lifestyle?.sports_interest || [],
      description: formData.habits_and_lifestyle?.description || ''
    },

    preferences: {
      min_age: formData.preferences?.min_age || '',
      max_age: formData.preferences?.max_age || '',
      min_height: {
        value: formData.preferences?.min_height?.value || '',
        unit: formData.preferences?.min_height?.unit || 'feet'
      },
      education: formData.preferences?.education === "Other" && formData.preferences?.education_other 
        ? formData.preferences.education_other 
        : formData.preferences?.education || '',
      profession: formData.preferences?.profession === "Other" && formData.preferences?.profession_other 
        ? formData.preferences.profession_other 
        : formData.preferences?.profession || '',
      religion: formData.preferences?.religion === "Other" && formData.preferences?.religion_other 
        ? formData.preferences.religion_other 
        : formData.preferences?.religion || '',
      sect: formData.preferences?.sect === "Other" && formData.preferences?.sect_other 
        ? formData.preferences.sect_other 
        : formData.preferences?.sect || '',
      caste: formData.preferences?.caste === "Other" && formData.preferences?.caste_other 
        ? formData.preferences.caste_other 
        : formData.preferences?.caste || '',
      city: formData.preferences?.city === "Other" && formData.preferences?.city_other 
        ? formData.preferences.city_other 
        : formData.preferences?.city || '',
      country: formData.preferences?.country === "Other" && formData.preferences?.country_other 
        ? formData.preferences.country_other 
        : formData.preferences?.country || '',
      marital_status: formData.preferences?.marital_status === "Other" && formData.preferences?.marital_status_other 
        ? formData.preferences.marital_status_other 
        : formData.preferences?.marital_status || '',
      profession_preference: formData.preferences?.profession_preference || [],
      location_preference: formData.preferences?.location_preference || [],
      preferred_languages: formData.preferences?.preferred_languages || [],
      smoking_preference: formData.preferences?.smoking_preference === "Other" && formData.preferences?.smoking_preference_other 
        ? formData.preferences.smoking_preference_other 
        : formData.preferences?.smoking_preference || '',
      drinking_preference: formData.preferences?.drinking_preference === "Other" && formData.preferences?.drinking_preference_other 
        ? formData.preferences.drinking_preference_other 
        : formData.preferences?.drinking_preference || ''
    },

    documents_verification: {
      cnic_verified: formData.documents_verification?.cnic_verified || false,
      education_verified: formData.documents_verification?.education_verified || false,
      employment_verified: formData.documents_verification?.employment_verified || false
    }
  };
};

// Format profile for WhatsApp with clean JSON
export const formatProfileForWhatsApp = (formData) => {
  if (!formData) return '';

  const cleanedProfile = createCleanedProfile(formData);

  const summary = `
🌟*New Profile*🌟
*Name:* ${formData.personal_details?.full_name || 'N/A'}
*Profile ID:* ${formData.profile_id}
*Gender:* ${formData.personal_details?.gender || 'N/A'}
*Age:* ${formData.personal_details?.date_of_birth || 'N/A'}
*City:* ${formData.residence?.city || 'N/A'}
*Created By:* ${formData.profile_created_by || 'N/A'}

${JSON.stringify(cleanedProfile, null, 2)}
  `.trim();

  return summary;
};

// Helper to prepare form data for submission (keeping for backward compatibility)
export const prepareFormData = (formData) => {
  const prepared = JSON.parse(JSON.stringify(formData)); // Deep clone

  // Process all fields that have "Other" options
  prepared.profile_created_by = getActualValue(
    formData.profile_created_by,
    formData.profile_created_by_other
  );

  prepared.guardian_details.relation = getActualValue(
    formData.guardian_details.relation,
    formData.guardian_details.relation_other
  );

  prepared.physical_details.body_type = getActualValue(
    formData.physical_details.body_type,
    formData.physical_details.body_type_other
  );

  prepared.physical_details.complexion = getActualValue(
    formData.physical_details.complexion,
    formData.physical_details.complexion_other
  );

  prepared.religious_details.religion = getActualValue(
    formData.religious_details.religion,
    formData.religious_details.religion_other
  );

  prepared.religious_details.sect = getActualValue(
    formData.religious_details.sect,
    formData.religious_details.sect_other
  );

  prepared.religious_details.caste = getActualValue(
    formData.religious_details.caste,
    formData.religious_details.caste_other
  );

  prepared.religious_details.religious_practice_level = getActualValue(
    formData.religious_details.religious_practice_level,
    formData.religious_details.practice_level_other
  );

  prepared.marital_details.marital_status = getActualValue(
    formData.marital_details.marital_status,
    formData.marital_details.marital_status_other
  );

  prepared.education.highest_degree = getActualValue(
    formData.education.highest_degree,
    formData.education.highest_degree_other
  );

  prepared.profession.employment_type = getActualValue(
    formData.profession.employment_type,
    formData.profession.employment_type_other
  );

  prepared.residence.country = getActualValue(
    formData.residence.country,
    formData.residence.country_other
  );

  prepared.residence.city = getActualValue(
    formData.residence.city,
    formData.residence.city_other
  );

  prepared.residence.residential_status = getActualValue(
    formData.residence.residential_status,
    formData.residence.residential_status_other
  );

  prepared.family.family_type = getActualValue(
    formData.family.family_type,
    formData.family.family_type_other
  );

  prepared.family.family_status = getActualValue(
    formData.family.family_status,
    formData.family.family_status_other
  );

  prepared.health.blood_group = getActualValue(
    formData.health.blood_group,
    formData.health.blood_group_other
  );

  prepared.health.disability = getActualValue(
    formData.health.disability,
    formData.health.disability_other
  );

  prepared.health.smoking = getActualValue(
    formData.health.smoking,
    formData.health.smoking_other
  );

  prepared.health.drinking = getActualValue(
    formData.health.drinking,
    formData.health.drinking_other
  );

  prepared.habits_and_lifestyle.diet = getActualValue(
    formData.habits_and_lifestyle.diet,
    formData.habits_and_lifestyle.diet_other
  );

  prepared.personal_details.mother_tongue = getActualValue(
    formData.personal_details.mother_tongue,
    formData.personal_details.mother_tongue_other
  );

  prepared.preferences.religion = getActualValue(
    formData.preferences.religion,
    formData.preferences.religion_other
  );

  prepared.preferences.smoking_preference = getActualValue(
    formData.preferences.smoking_preference,
    formData.preferences.smoking_preference_other
  );

  prepared.preferences.drinking_preference = getActualValue(
    formData.preferences.drinking_preference,
    formData.preferences.drinking_preference_other
  );

  // Remove the _other fields since we've processed them
  const otherFieldsToRemove = [
    'profile_created_by_other',
    'guardian_details.relation_other',
    'physical_details.body_type_other',
    'physical_details.complexion_other',
    'religious_details.religion_other',
    'religious_details.sect_other',
    'religious_details.caste_other',
    'religious_details.practice_level_other',
    'marital_details.marital_status_other',
    'education.highest_degree_other',
    'profession.employment_type_other',
    'residence.country_other',
    'residence.city_other',
    'residence.residential_status_other',
    'family.family_type_other',
    'family.family_status_other',
    'health.blood_group_other',
    'health.disability_other',
    'health.smoking_other',
    'health.drinking_other',
    'habits_and_lifestyle.diet_other',
    'personal_details.mother_tongue_other',
    'preferences.religion_other',
    'preferences.smoking_preference_other',
    'preferences.drinking_preference_other'
  ];

  otherFieldsToRemove.forEach(field => {
    const parts = field.split('.');
    if (parts.length === 1) {
      delete prepared[field];
    } else if (parts.length === 2) {
      if (prepared[parts[0]]) {
        delete prepared[parts[0]][parts[1]];
      }
    }
  });

  return prepared;
};

// Get phone number for display
export const getPhoneDisplay = (countryCode, phoneNumber) => {
  if (!phoneNumber) return "";
  if (!countryCode) return phoneNumber;
  return `${countryCode}${phoneNumber}`;
};

// Validate height input
export const validateHeightInput = (value, unit) => {
  if (!value) return { isValid: false, error: "Height is required" };

  if (unit === "feet") {
    // Try to parse feet'inches" format
    const feetInchesPattern = /^(\d{1,2})'(\d{1,2})"?$/;
    const feetInchesMatch = value.match(feetInchesPattern);

    if (feetInchesMatch) {
      const feet = parseInt(feetInchesMatch[1]);
      const inches = parseInt(feetInchesMatch[2]);

      if (feet < 3 || feet > 9) {
        return { isValid: false, error: "Feet should be between 3 and 9" };
      }

      if (inches < 0 || inches > 11) {
        return { isValid: false, error: "Inches should be between 0 and 11" };
      }

      if (feet === 9 && inches > 0) {
        return { isValid: false, error: "Maximum height is 9'0\"" };
      }

      return { isValid: true, error: "" };
    }

    // Try to parse decimal format
    const decimalPattern = /^(\d{1,2})\.(\d{1,2})$/;
    const decimalMatch = value.match(decimalPattern);

    if (decimalMatch) {
      const feet = parseInt(decimalMatch[1]);
      const decimalPart = decimalMatch[2];

      if (feet < 3 || feet > 9) {
        return { isValid: false, error: "Feet should be between 3 and 9" };
      }

      let inches;
      if (decimalPart.length === 2 && decimalPart.startsWith('1')) {
        inches = parseInt(decimalPart);
      } else if (decimalPart.length === 2) {
        inches = parseInt(decimalPart);
      } else if (decimalPart.length === 1) {
        inches = parseInt(decimalPart);
      } else {
        return { isValid: false, error: "Invalid format. Use feet.inches (e.g., 5.8, 5.10)" };
      }

      if (isNaN(inches) || inches < 0 || inches > 11) {
        return { isValid: false, error: "Inches should be between 0 and 11" };
      }

      if (feet === 9 && inches > 0) {
        return { isValid: false, error: "Maximum height is 9'0\"" };
      }

      return { isValid: true, error: "" };
    }

    // Try to parse just feet
    const justFeetPattern = /^(\d{1,2})$/;
    const justFeetMatch = value.match(justFeetPattern);

    if (justFeetMatch) {
      const feet = parseInt(justFeetMatch[1]);

      if (feet < 3 || feet > 9) {
        return { isValid: false, error: "Feet should be between 3 and 9" };
      }

      return { isValid: true, error: "" };
    }

    return { isValid: false, error: "Use format: feet'inches\" (e.g., 5'8\") or feet.inches (e.g., 5.8, 5.10)" };
  } else {
    // Centimeter mode
    const cm = parseInt(value);
    if (isNaN(cm)) {
      return { isValid: false, error: "Please enter a valid number" };
    }

    if (cm < 100 || cm > 250) {
      return { isValid: false, error: "Height should be between 100cm and 250cm" };
    }

    return { isValid: true, error: "" };
  }
};